export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13524.5d25640c.jpg";